module.exports = __webpack_public_path__ + "img/wechat_icon.1f18568e.png";